<template>
  <div class="gywm">
	<div class="gywm_til">
		{{gywm.title}}
	</div>
	<div class="gywm_cen">
		{{gywm.content}}
	</div>
	<div class="gywm_box">
		<div class="gywm_box_for" v-for="(item,index) in gywm.department" :key="index">  
			<div class="gywm_box_for_img">
				<img :src="item.cover" />
			</div>
			<div class="gywm_box_for_name">
				{{item.title}}
			</div>
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		gywm:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.gywm{
	width: 1200px;
	
	// height: 100vh;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	.gywm_til{
		// font-size: 23px;
		font-size: 18px;
		
		font-weight: 400;
		color: #000000;
		text-align: center;
		margin-bottom: 40px;
	}
	.gywm_cen{
		
		font-size: 18px;
		
		font-weight: 400;
		color: #000000;
		text-align: center;
		margin-bottom: 71px;
	}
	.gywm_box{
		display: flex;
		justify-content: center;
		margin-bottom: 158px;
		.gywm_box_for:not(:last-child){
			margin-right: 81px;
		}
		.gywm_box_for{
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			.gywm_box_for_img{
				width: 85px;
				height: 85px;
				margin-bottom: 20px;
				img{
					width: 85px;
					height: 85px;
				}
			}
			.gywm_box_for_name{
				font-size: 18px;
				
				font-weight: 400;
				color: #000000;
			}
		}
	}
}
@media screen and (max-width:1200px) {
	.gywm{
		width: 100% !important;
		padding: 0 30px !important;
		box-sizing: border-box;
		.gywm_til{
			font-size: 16px !important;
			margin-bottom: 20px !important;
		}
		.gywm_cen{
			font-size: 16px !important;
			margin-bottom: 20px !important;
		}
		.gywm_box{
			margin-bottom: 20px !important;
			justify-content: space-between !important;
			.gywm_box_for{
				margin-right: 10px !important;
				.gywm_box_for_img{
					width: 40px !important;
					height: 40px !important;
					img{
						width: 40px !important;
						height:40px !important;
					}
				}
				.gywm_box_for_name{
					font-size: 16px !important;
				}
			}
		}
		
		
	}
}
</style>
